<template>
    <div class="languages">
        <div
            v-for="(item, i) in languageData"
            :key="item.foreignLanguageId"
            class="languages__group-wrapper"
        >
            <div class="languages__select-wrapper">
                <ModelSelect
                    label="Выберите язык"
                    :items="sortedLangs"
                    item-value="id"
                    item-text="field_value"
                    :disabled-keys="disabledLanguageKeys"
                    class="languages__select"
                    v-model="item.foreignLanguageId"
                />
            </div>
            <div class="languages__select-wrapper">
                <ModelSelect
                    label="Уровень владения"
                    :items="dictionaryByType('level_language')"
                    item-value="id"
                    item-text="field_value"
                    class="languages__select"
                    :disabled="item.foreignLanguageId === null"
                    v-model="item.foreignLanguageLevelId"
                />
            </div>
            <span
                v-if="isMobile"
                class="languages__remove-new-language languages__remove-new-language_type_mobile"
                @click="removeLanguage(i)"
            >
            </span>
            <div
                v-else
                class="languages__select-wrapper languages__select-wrapper_icon"
            >
                <span
                    class="languages__remove-new-language"
                    @click="removeLanguage(i)"
                >
                </span>
            </div>
        </div>
        <div
            class="add-block-btn"
            :class="{ 'add-block-btn--mt': languageData.length }"
            data-voicetext="Добавить язык"
            @click="addMoreLanguage(true)"
        >
            Добавить язык
        </div>
    </div>
</template>

<script>
import ModelSelect from '../../../../UI/models/ModelSelect';

import { mapActions, mapGetters } from 'vuex';

const languageTemplate = {
    foreignLanguageId: null,
    foreignLanguageLevelId: null,
};

const getters = ['dictionaryByType', 'isMobile'];

const actions = ['loadDictionaryItems'];

export default {
    name: 'WideLanguagesData',
    props: {
        languageData: Array,
    },
    model: {
        prop: 'languageData',
        event: 'change',
    },
    components: {
        ModelSelect,
    },
    computed: {
        ...mapGetters(getters),
        disabledLanguageKeys() {
            const languages = this.languageData;
            const res = (languages || [])
                .map(v => v.foreignLanguageId)
                .filter(v => v);

            return res;
        },
        sortedLangs() {
            const collator = new Intl.Collator('ru');
            return this.dictionaryByType('languages').sort((a, b) => {
                return collator.compare(a.field_value, b.field_value);
            });
        },
    },
    methods: {
        ...mapActions(actions),
        addMoreLanguage() {
            this.languageData.push({
                ...languageTemplate,
            });
        },
        removeLanguage(i) {
            this.languageData.splice(i, 1);
        },
    },
    async mounted() {
        this.loadDictionaryItems('languages');
        this.loadDictionaryItems('level_language');
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
.languages {
    &__group-wrapper {
        display: flex;
        position: relative;
        flex-direction: column;
        align-items: flex-start;

        @include on-desktop {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

    &__select {
        width: 100%;
    }

    &__select-wrapper {
        position: relative;
        width: 85%;

        @include on-desktop {
            width: 24.43313rem;
        }
    }

    &__remove-new-language {
        position: absolute;
        cursor: pointer;
        width: 1rem;
        height: 1rem;
        left: -10px;
        top: -0.5rem;
        background: url('assets/icons/languages__btn-delete.svg') no-repeat
            center;
        background-size: cover;

        left: unset;
        &_type {
            &_mobile {
                position: absolute;
                cursor: pointer;
                width: 24px;
                height: 24px;
                right: 8px;
                top: 30px;
                background: url('assets/icons/languages__btn-delete.svg')
                    no-repeat center;
                background-size: cover;
            }
        }
    }
}
</style>
